export type AssignmentAction = (typeof AssignmentAction)[keyof typeof AssignmentAction];

export const AssignmentAction = {
    Assign: 'Assign',
    Revoke: 'Revoke',
} as const;
